import { useState, useRef, useEffect } from "react";
import { Input } from "@/components/ui/input";

interface EditableCellProps {
  value: string;
  onSave: (newValue: string) => void;
  className?: string;
  disabled?: boolean;
}

export function EditableCell({ value, onSave, className = "", disabled = false }: EditableCellProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(value);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [isEditing]);

  const handleDoubleClick = () => {
    if (disabled) return;
    setIsEditing(true);
    setEditValue(value);
  };

  const handleSave = () => {
    if (editValue !== value) {
      onSave(editValue);
    }
    setIsEditing(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleSave();
    } else if (e.key === "Escape") {
      setEditValue(value);
      setIsEditing(false);
    }
  };

  if (isEditing) {
    return (
      <Input
        ref={inputRef}
        value={editValue}
        onChange={(e) => setEditValue(e.target.value)}
        onBlur={handleSave}
        onKeyDown={handleKeyDown}
        className="h-7 text-sm py-0 px-2"
      />
    );
  }

  return (
    <div
      onDoubleClick={handleDoubleClick}
      className={`${disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer hover:bg-muted/50'} rounded px-1 -mx-1 ${className}`}
      title={disabled ? "Edição desabilitada" : "Duplo clique para editar"}
    >
      {value || "-"}
    </div>
  );
}
